// extracted by mini-css-extract-plugin
export var previewContainer = "_ss-0";